module.exports = __webpack_public_path__ + "images/pt-amy-and-dave.png";